export default "__VITE_ASSET__N8ppxP_z__"